import { RelodeApiError } from "@relode/core";

import { CandidateDetails } from "../../../../shared/types";
import { ErrorType } from "./errorType";

export interface ClientPublicCandidateState {
    ui: {
        errors: {
            type: string;
            message?: string;
            apiError?: RelodeApiError;
        }[];
        error?: {
            type: ErrorType;
            message?: string;
            apiError?: RelodeApiError;
        };
        isCandidateLoading: boolean;
        selectedCandidateTab?: string;
    };
    data: {
        candidate: CandidateDetails;
    };
}

export const initialClientPublicCandidateState: ClientPublicCandidateState = {
    ui: {
        isCandidateLoading: false,
        error: undefined,
        errors: [],
        selectedCandidateTab: "profile",
    },
    data: {
        candidate: undefined,
    },
};
